import React, { useEffect, useState } from "react";
import style from "./wallet.module.scss";
import Skeleton from "../skeleton/skeleton"
{/* <Skeleton type='rectangle' width='280px' height='44px' /> */ }
const WalletSkeleton = (props) => {

    return <div className={style.wrapper}>
        <div className={style.header}>
            <h1><Skeleton type='rectangle' width='96px' height='44px' /></h1>
            <div className={style.buttonsWrapper}>
                <div className={style.settingButton}>
                    <Skeleton type='rectangle' width='103px' height='44px' />
                </div>
                <div className={style.settingButton}>
                    <Skeleton type='rectangle' width='136px' height='44px' />
                </div>
            </div>
        </div>

        <div className={style.chargeStatus}>
            <Skeleton type='rectangle' width='300px' height='100px' />
            <Skeleton type='rectangle' width='300px' height='100px' />
        </div>

        <div className={style.pagination} style={{ display: 'inline-flex', flexDirection: 'row', gap: '12px', marginTop: '40px', flexWrap: 'wrap' }}>
            <Skeleton type='rectangle' width='136px' height='44px' />
            <Skeleton type='rectangle' width='72px' height='44px' />
            <Skeleton type='rectangle' width='145px' height='44px' />
            <Skeleton type='rectangle' width='57px' height='44px' />
        </div>

        <div className={style.logListWrapper} style={{ width: '100%', display: 'inline-flex', flexDirection: 'column', gap: '12px', marginTop: '40px', flexWrap: 'wrap' }}>
            <Skeleton type='rectangle' width='100%' height='64px' />
            <Skeleton type='rectangle' width='100%' height='64px' />
            <Skeleton type='rectangle' width='100%' height='64px' />
            <Skeleton type='rectangle' width='100%' height='64px' />
            <Skeleton type='rectangle' width='100%' height='64px' />
            <Skeleton type='rectangle' width='100%' height='64px' />
        </div>
    </div>
}
export default WalletSkeleton;
